export default __webpack_public_path__ + "static/9-0c3d0bbf1e545fa5a20802eeb524e152.png";